import { CrudList } from '../shared/CrudPage';
import { brandService } from '@kss/api';
import type { Brand, BrandCreate, BrandFilter } from '@kss/api';
import { StatusBadge, Thumbnail } from '@kss/ui';

/**
 * Brands list — wired to /api/Brand/all (live since 2026-05-02).
 *
 * Replaced the previous localStorage stub once the controller shipped.
 * Brand row also serves the NewProduct brand picker (via
 * `loadBrandOptions` in `formLoaders.ts`) so the storefront can show
 * canonical brand names instead of free-text strings.
 */
export default function AllBrands() {
  return (
    <CrudList<Brand, BrandCreate, BrandFilter>
      title="All brands"
      newLabel="New brand"
      service={brandService}
      idKey="brandId"
      labelKey="name"
      basePath="/panel/brands"
      module="Brand"
      columns={[
        {
          accessor: 'logoUrl',
          title: '',
          width: 52,
          sortable: false,
          render: (r) => <Thumbnail src={r.logoUrl} name={r.name} seed={r.brandId ?? r.name} />,
        },
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        { accessor: 'description', title: 'Description', render: (r) => r.description || '—' },
        {
          accessor: 'isActive',
          title: 'Status',
          sortable: true,
          render: (r) => <StatusBadge status={r.isActive ? 'active' : 'inactive'} />,
        },
      ]}
    />
  );
}
